/**
 * Product Upsell Bundle Selection Handler
 * Updates sticky button UI when user selects different bundle options
 */

function createProductUpsell(container) {
  const productId = container.dataset.productId;
  let selectedOption = null;
  let originalProductData = null;

  const getStickyElements = () => {
    const stickyForm = document.querySelector('.product-sticky-form');
    if (!stickyForm) return null;

    const stickyMedia = stickyForm.querySelector('[data-sticky-product-media]');
    const priceContainer = stickyForm.querySelector('.price');

    return {
      form: stickyForm,
      image: stickyMedia?.querySelector('img'),
      title: stickyForm.querySelector('.text-base.font-medium.leading-tight'),
      options: stickyForm.querySelector('[data-sticky-product-options]'),
      priceRegular: priceContainer?.querySelector('.price__regular'),
      priceSale: priceContainer?.querySelector('.price__sale')
    };
  };

  function captureOriginalData() {
    const elements = getStickyElements();
    if (!elements) return;

    originalProductData = {
      image: elements.image?.src,
      imageSrcset: elements.image?.srcset,
      title: elements.title?.textContent,
      options: elements.options?.textContent,
      priceRegular: elements.priceRegular?.innerHTML,
      priceSale: elements.priceSale?.innerHTML
    };

    console.log('📦 Original product data captured');
  }

  function updateStickyButton() {
    const elements = getStickyElements();
    if (!elements || !selectedOption) return;

    if (selectedOption.type === 'single') {
      if (!originalProductData) return;

      if (elements.image && originalProductData.image) {
        elements.image.src = originalProductData.image;
        elements.image.srcset = originalProductData.imageSrcset || '';
      }
      if (elements.title) elements.title.textContent = originalProductData.title;
      if (elements.options) elements.options.textContent = originalProductData.options;
      if (elements.priceRegular) elements.priceRegular.innerHTML = originalProductData.priceRegular;

      if (elements.priceSale) {
        if (originalProductData.priceSale) {
          elements.priceSale.innerHTML = originalProductData.priceSale;
          elements.priceSale.style.display = '';
        } else {
          elements.priceSale.style.display = 'none';
        }
      }

      console.log('🔄 Sticky button reverted to original product');
      return;
    }

    if (elements.image && selectedOption.image) {
      elements.image.src = selectedOption.image;
      const imageUrl = selectedOption.image.split('?')[0];
      elements.image.srcset = `${imageUrl}?width=80 80w, ${imageUrl}?width=160 160w`;
    }

    if (elements.title) {
      elements.title.textContent = selectedOption.title;
    }

    if (elements.options) {
      const countText = selectedOption.productCount > 1
        ? `Kit com ${selectedOption.productCount} unidades`
        : 'Kit bundle';
      elements.options.textContent = countText;
    }

    if (elements.priceRegular) {
      elements.priceRegular.textContent = selectedOption.price;
    }

    if (elements.priceSale) {
      if (selectedOption.comparePrice) {
        elements.priceSale.textContent = selectedOption.comparePrice;
        elements.priceSale.style.display = '';
      } else {
        elements.priceSale.style.display = 'none';
      }
    }

    console.log('🎯 Sticky button updated:', {
      title: selectedOption.title,
      count: selectedOption.productCount
    });
  }

  function updateSelection(radio) {
    container.querySelectorAll('.product-upsell__card').forEach(card => {
      card.classList.remove('product-upsell__card--selected');
    });

    const selectedCard = radio.closest('.product-upsell__card');
    selectedCard?.classList.add('product-upsell__card--selected');

    selectedOption = {
      type: radio.value,
      variantId: radio.dataset.variantId,
      productId: radio.dataset.productId || productId,
      productCount: parseInt(radio.dataset.productCount || '1'),
      title: selectedCard.querySelector('.product-upsell__title')?.textContent.trim() || '',
      image: selectedCard.querySelector('.product-upsell__thumbnail')?.src || '',
      price: selectedCard.querySelector('.product-upsell__final-price')?.textContent.trim() || '',
      comparePrice: selectedCard.querySelector('.product-upsell__compare-price')?.textContent.trim() || ''
    };

    console.log('✅ Upsell selection updated:', selectedOption.type);

    updateStickyButton();
  }

  function setupEventListeners() {
    container.querySelectorAll('.product-upsell__radio').forEach(radio => {
      radio.addEventListener('change', (e) => updateSelection(e.target));
    });

    container.querySelectorAll('.product-upsell__card').forEach(card => {
      card.addEventListener('click', (e) => {
        if (e.target.classList.contains('product-upsell__radio')) return;

        const radio = card.querySelector('.product-upsell__radio');
        if (radio && !radio.checked) {
          radio.checked = true;
          updateSelection(radio);
        }
      });
    });
  }

  function init() {
    captureOriginalData();
    setupEventListeners();

    const firstRadio = container.querySelector('.product-upsell__radio:checked');
    if (firstRadio) updateSelection(firstRadio);

    console.log('✨ Product Upsell initialized');
  }

  init();
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-upsell').forEach(createProductUpsell);
});

if (typeof Shopify !== 'undefined' && Shopify.bind) {
  Shopify.bind(document, 'shopify:section:load', () => {
    document.querySelectorAll('.product-upsell').forEach(container => {
      if (!container.dataset.initialized) {
        createProductUpsell(container);
        container.dataset.initialized = 'true';
      }
    });
  });
}
